import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ScreenHeader from '../Subcomponents/ScreenHeader';
import ScreenContainer from '../Subcomponents/ScreenContainer';
import ScreenInstructions from '../Subcomponents/ScreenInstructions';
import FieldGroup from '../Subcomponents/FieldGroup';
import { getScreen } from '../../../actions/screenAction';
import ActionButton from '../Subcomponents/ActionButton';

class EnterZipCodeToPay extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            zipCodeIsValid: false,
            ZipCode: ''
        }
        this.updateZipCode = this.updateZipCode.bind(this);
        this.getNextScreen = this.getNextScreen.bind(this);
        this.cancelPayment = this.cancelPayment.bind(this);
    }

    componentWillReceiveProps(newProps){
        this.setState({zipCodeIsValid: newProps.values.ZipCodeValidForUser});
    }

    updateZipCode(event) {
        this.setState({zipCodeIsValid:event.target.value.length > 3});
        return this.setState({ZipCode: event.target.value});
    }

    getNextScreen (event) {
        let currentState = {
            Values: this.state
        };

        currentState.Values.PayButtonClicked = true;
        this.props.actions.getScreen(currentState, this.props.name);
    }

    cancelPayment(event) {
        event.preventDefault();  

        let currentState = {
            Values: {"USER_CANCELLED": true}
        };

        this.props.actions.getScreen(currentState, this.props.name);
    }

    render() {
    let textResources = this.props.textResources;
    let values = this.props.values;



    let zipCodeValid = this.state.ZipCode? this.state.zipCodeIsValid : true;
    zipCodeValid = values.EnteredZipCode && this.state.ZipCode == values.EnteredZipCode
                    ? values.ZipCodeValidForUser == "true"
                    : zipCodeValid;

    return (
            <ScreenContainer>
                <ScreenHeader title={textResources.HeaderTitle} text={textResources.HeaderText} icon={this.props.uiSpec.Icon}/>
                <ScreenInstructions title={textResources.InstructionTitle} text={textResources.InstructionText}/>
                <div className="o-pageSection o-pageSection--form">
                    <FieldGroup errorText={textResources.EnterValidZipCode} valid={zipCodeValid} label={textResources.ZipCode}>
                        <input name="ZipCode" type="text" className="c-Input" placeholder={textResources.ZipCodePlaceholder} value={this.state.number} onChange={this.updateZipCode}/>
                    </FieldGroup>

                    <div className="o-buttonContainer u-align-center">
                        <ActionButton action={this.getNextScreen} valid={this.state.zipCodeIsValid} text={textResources.ContinueButtonText} />
                        <a className="c-Btn c-Btn--secondary" onClick={this.cancelPayment}>{textResources.CancelButtonText}</a>
                    </div>
                </div>
            </ScreenContainer>
        );
    }
}



EnterZipCodeToPay.propTypes = {
    name: React.PropTypes.string.isRequired,
    values: React.PropTypes.object.isRequired,
    uiSpec: React.PropTypes.object.isRequired,
    textResources: React.PropTypes.object.isRequired,
        actions: React.PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps){
    return {
    };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({getScreen}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EnterZipCodeToPay);


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Payment/EnterZipCodeToPay.js
 **/